import { render, staticRenderFns } from "./UserFarmReject.vue?vue&type=template&id=51dd1be4&scoped=true"
import script from "./UserFarmReject.vue?vue&type=script&lang=js"
export * from "./UserFarmReject.vue?vue&type=script&lang=js"
import style0 from "./UserFarmReject.vue?vue&type=style&index=0&id=51dd1be4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd1be4",
  null
  
)

export default component.exports